import { consumer } from '@tock/coretypes';
import { isOrderVariety } from '@tock/shared/utils/offerings/varietyQueries';

const allVailBusinesses = [
  { id: 6643, name: 'Sevens' },
  { id: 6645, name: 'Alpenglow Stube' },
  { id: 6649, name: 'Bighorn Bistro & Lounge' },
  { id: 6650, name: 'Keystone Staff Meal' },
  { id: 6656, name: 'Keystone Ranch Restaurant' },
  { id: 6657, name: 'Ski Tip Lodge' },
  { id: 8349, name: 'Keystone Dinner Sleigh Ride' },
  { id: 20031, name: 'Alps Chalet' },
  { id: 20033, name: "Paul's Pub" },
  { id: 20036, name: 'Spruce Saddle Lodge' },
  { id: 20039, name: 'Talons' },
  { id: 20041, name: 'The Maggie Restaurant' },
  { id: 20042, name: 'The Overlook Restaurant' },
  { id: 20043, name: 'Pioneer Crossing' },
  { id: 20046, name: 'Ski Hill Grill ' },
  { id: 20048, name: 'TenMile Station ' },
  { id: 20049, name: 'Vista Haus ' },
  { id: 20051, name: 'California Lodge' },
  { id: 20052, name: 'East Peak Restaurant & Lodge' },
  { id: 20054, name: 'Tamarack Lodge F&B' },
  { id: 20055, name: 'Marketplace at Hunter Mountain' },
  { id: 20058, name: 'Summit House' },
  { id: 20061, name: 'Timber Ridge / Outpost ' },
  { id: 20064, name: 'Mountain House Cafe' },
  { id: 20067, name: 'Alpine Market' },
  { id: 20070, name: 'Main Base Lodge' },
  { id: 20071, name: 'Big Springs Day Lodge' },
  { id: 20072, name: 'Zephyr' },
  { id: 20075, name: 'Okemo Mtn Resort: Base Lodge' },
  { id: 20078, name: 'Cloud Dine' },
  { id: 20080, name: 'Legacy Cafe' },
  { id: 20082, name: 'Mid Mountain' },
  { id: 20085, name: 'Miners Camp' },
  { id: 20088, name: 'Red Pine Lodge' },
  { id: 20089, name: 'Summit House Park City' },
  { id: 20091, name: 'Roundtop Mountain Resort' },
  { id: 20093, name: 'The Great Room Grill at Spruce Camp Base Lodge' },
  { id: 20094, name: 'Eagles Nest Food' },
  { id: 20095, name: 'Wildwood Smokehouse' },
  { id: 20097, name: 'Mid Vail' },
  { id: 20100, name: 'Two Elk' },
  { id: 20101, name: 'Glacier Creek Lodge (Blackcomb)' },
  { id: 20103, name: 'Rendezvous Restaurant (Blackcomb)' },
  { id: 20104, name: 'Roundhouse Lodge (Whistler)' },
  { id: 20105, name: 'The 10th' },
  { id: 20109, name: 'Ski Hill Grill - Wilmot' },
  { id: 20543, name: 'The Living Room' },
  { id: 20545, name: '9600 Kitchen' },
  { id: 20663, name: 'Keystone Resort – Ready to Heat Family Meals' },
  { id: 20698, name: 'Roundhouse Cafe Okemo' },
  { id: 20860, name: 'Cascadian Kitchen - Stevens Pass' },
  { id: 20864, name: 'The Farm - Park City' },
  { id: 20867, name: 'Red Tail Grill - Canyons Village Base (NOT Red Pine Lodge on Mountain)' },
  { id: 20868, name: "Murdock's Cafe & Pizzeria - Park City" },
  { id: 20871, name: 'Grand Summit Hotel: Pre-Order Breakfast for Next Day' },
  { id: 20872, name: 'Grand Summit Hotel - To Go' },
  { id: 20873, name: 'AAC - Fitness Area' },
  { id: 20874, name: 'Arrowhead Alpine Club - Lounge' },
  { id: 20875, name: "Merlin's Bar & Grill - Whistler" },
  { id: 20878, name: 'Garibaldi Lift Co.' },
  { id: 20879, name: "Dusty's Bar & BBQ" },
  { id: 20881, name: 'Bachelor Gulch Club' },
  { id: 21088, name: "Christine's on Blackcomb" },
  { id: 21091, name: 'Steeps Grill & Wine Bar' },
  { id: 21396, name: 'The Arrabelle Club' },
  { id: 21423, name: 'Sun Lodge' },
  { id: 21433, name: 'Vail Mountain Club' },
  { id: 21702, name: 'Bourbon Pub Northstar' },
  { id: 21745, name: 'Beaver Creek Club' },
  { id: 21779, name: 'The Passport Club at Golden Peak' },
  { id: 21881, name: 'Carinthia' },
  { id: 21916, name: 'Mountain House Go Big Burger' },
  { id: 21918, name: 'Carinthia Lodge' },
  { id: 22049, name: 'Keystone Lodge Room Service' },
  { id: 22192, name: 'Cucina at The Lodge at Vail' },
  { id: 22236, name: 'Coleman Brook Tavern' },
  { id: 22634, name: 'Game Creek Club' },
  { id: 22706, name: 'Made Market' },
];

export const isVailReservation = (booking: consumer.IPurchaseSummary) => {
  const isNotToGo = !isOrderVariety(booking.ticketType?.variety);
  const businessId = booking.business?.id;
  return isNotToGo && allVailBusinesses.some((business) => business.id === businessId);
};
